import axios from '../config/axiosConfig';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SiGoogleforms } from 'react-icons/si';
import { MdDashboard, MdGroup, MdGroupAdd, MdPersonAdd, MdAddCircle, MdFolder, MdReceipt, MdLink, MdStar, MdSettings, MdCollections, MdArticle, MdLightMode, MdDarkMode, MdSettingsSystemDaydream, MdPeople, MdMale, MdFemale, MdEvent } from 'react-icons/md';
import PressMediaList from '../components/dashboard/PressMediaList';
import BroadcastingMediaList from '../components/dashboard/BroadcastingMediaList';
import DigitalMediaList from '../components/dashboard/DigitalMediaList';
import CitizenReporterList from '../components/dashboard/CitizenReporterList';
import DashboardNaiNews from '../components/dashboard/DashboardNaiNews';
import AddNaiNews from '../components/dashboard/AddNaiNews';
import EditNaiNews from '../components/dashboard/EditNaiNews';
import DashboardGallery from '../components/dashboard/DashboardGallery';
import AddGallery from '../components/dashboard/AddGallery';
import EditGallery from '../components/dashboard/EditGallery';
import AddMember from '../components/dashboard/AddMember';
import MembersList from '../components/dashboard/MembersList';
import EditMember from '../components/dashboard/EditMember';
import MemberDetails from '../components/dashboard/MemberDetails';
import Wings from '../components/dashboard/Wings';
import Settings from '../components/dashboard/Settings';
import Receipts from '../components/dashboard/Receipts';
import MemberReferences from '../components/dashboard/MemberReferences';
import InteractiveMaps from '../components/dashboard/InteractiveMaps';
import EventsManager from '../components/dashboard/EventsManager';
import AddEvent from '../components/dashboard/AddEvent';
import EditEvent from '../components/dashboard/EditEvent';
import VisitorAnalyticsWidget from '../components/dashboard/VisitorAnalyticsWidget';
import DetailedVisitorAnalytics from '../components/dashboard/DetailedVisitorAnalytics';
import { MdInsights } from 'react-icons/md';

const Layout = ({ children, user, handleLogout, activeItem, setActiveItem, handleMenuClick }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [expandedMenus, setExpandedMenus] = useState({});

  const toggleMenu = (name) => {
    setExpandedMenus(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const menuItems = [
    { name: 'Dashboard', icon: <MdDashboard className="w-5 h-5" /> },
    { 
      name: 'Online Forms', 
      icon: <SiGoogleforms className="w-5 h-5" />, 
      hasDropdown: true,
      subItems: [
        'Press Media Forms',
        'Broadcasting Media Forms',
        'Digital Media Forms',
        'Citizen Reporter Forms'
      ]
    },
    { name: 'All Members', icon: <MdGroup className="w-5 h-5" /> },
    // { name: 'Members', 
    //   icon: <MdPerson className="w-5 h-5" />, 
    //   hasDropdown: true,
    //   subItems: [
    //     'NAI Members',
    //     'DMCR Members'
    //   ] },
    { name: 'Leaders', icon: <MdGroupAdd className="w-5 h-5" /> },
    { name: 'Add Members', icon: <MdPersonAdd className="w-5 h-5" /> },
    { name: 'Wings', icon: <MdAddCircle className="w-5 h-5" /> },
    { name: 'NAI Files', icon: <MdFolder className="w-5 h-5" /> },
    { name: 'NAI News', icon: <MdArticle className="w-5 h-5" /> },
    { name: 'NAI Gallery', icon: <MdCollections className="w-5 h-5" /> },
    { name: 'NAI Events', icon: <MdEvent className="w-5 h-5" /> },
    { name: 'Receipts', 
      icon: <MdReceipt className="w-5 h-5" />,
      hasDropdown: true,
      subItems: ['Receipts Dashboard', 'All Receipts']
    },
    { name: 'Visitor Statistics', icon: <MdInsights className="w-5 h-5" /> },
    { name: 'References', icon: <MdLink className="w-5 h-5" /> },
    { name: 'Wishes', icon: <MdStar className="w-5 h-5" />, hasDropdown: true },
    { name: 'Settings', icon: <MdSettings className="w-5 h-5" /> },
  ];

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <div className={`flex-shrink-0 bg-[#212121] text-white flex flex-col transition-all duration-300 ${isSidebarOpen ? 'w-64' : 'w-0 overflow-hidden'}`}>
        {/* Logo Section */}
        <div className="flex items-center justify-center h-40 bg-[#212121]">
            <img src="/images/nailogo.png" alt="NAI Logo" className="h-28 w-auto" />
        </div>

        {/* Menu Items */}
        <nav className="flex-1 px-4 py-4 space-y-2 overflow-y-auto">
          {menuItems.map((item) => (
            <div key={item.name}>
                <button
                  onClick={() => {
                      if (item.hasDropdown) {
                          toggleMenu(item.name);
                      } else {
                          handleMenuClick(item.name);
                      }
                  }}
                  className={`w-full flex items-center justify-between px-4 py-3 text-sm font-medium rounded-md transition-colors duration-200 focus:outline-none ${
                    activeItem === item.name
                      ? 'bg-gray-800 text-white'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }`}
                >
                  <div className="flex items-center text-left break-words pr-2">
                    <span className="mr-3 flex-shrink-0">{item.icon}</span>
                    <span className="whitespace-normal leading-tight">{item.name}</span>
                  </div>
                  {item.hasDropdown && (
                     <svg className={`w-4 h-4 transition-transform duration-200 
                      ${expandedMenus[item.name] ? 'transform rotate-180' : ''}`} 
                      fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                      d="M19 9l-7 7-7-7"></path></svg>
                  )}
                </button>
                
                {/* Sub-menu rendering */}
                {item.hasDropdown && expandedMenus[item.name] && item.subItems && (
                    <div className="pl-12 space-y-1 mt-1">
                        {item.subItems.map((subItem) => (
                            <button
                                key={subItem}
                                onClick={() => handleMenuClick(subItem)}
                                className={`block w-full text-left py-2 text-sm text-gray-400 hover:text-white transition-colors duration-200 whitespace-normal break-words pr-2 ${activeItem === subItem ? 'text-white font-semibold' : ''}`}
                            >
                                {subItem}
                            </button>
                        ))}
                    </div>
                )}
            </div>
          ))}

        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Header */}
        <header className="bg-white shadow border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
            <div className="w-full py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
                <div className="flex items-center">
                    {!isSidebarOpen && (
                        <img src="/images/nailogo.jpeg" alt="NAI Logo" className="h-10 w-auto mr-4 rounded" />
                    )}
                    {/* Toggle Button */}
                    <button
                        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                        className="text-[#99D950] p-2 rounded-md hover:bg-gray-100 focus:outline-none"
                        style={{ backgroundColor: '#99D950', color: 'white' }}
                    >
                        {isSidebarOpen ? (
                             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7"></path></svg>
                        ) : (
                             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"></path></svg>
                        )}
                    </button>
                </div>

                <div className="flex items-center gap-4">
                    <ThemeToggle />
                    <button
                        onClick={handleLogout}
                         className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md text-sm font-medium flex items-center transition-colors duration-200"
                    >
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg>
                        Logout
                    </button>
                </div>
            </div>
        </header>

        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-8">
            {children}
        </main>
      </div>
    </div>
  );
};

// ... (previous layout code unchaged) ...

const ThemeToggle = () => {
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'system');

    useEffect(() => {
        const root = window.document.documentElement;
        
        const applyTheme = (currentTheme) => {
            root.classList.remove('light', 'dark');
            if (currentTheme === 'system') {
                const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
                root.classList.add(systemPrefersDark ? 'dark' : 'light');
            } else {
                root.classList.add(currentTheme);
            }
        };

        applyTheme(theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    const cycleTheme = () => {
        if (theme === 'light') setTheme('dark');
        else if (theme === 'dark') setTheme('system');
        else setTheme('light');
    };

    return (
        <button 
            onClick={cycleTheme}
            className="p-2 rounded-full text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 transition-colors"
            title={`Current mode: ${theme.charAt(0).toUpperCase() + theme.slice(1)}`}
        >
            {theme === 'light' && <MdLightMode className="w-5 h-5 text-yellow-500" />}
            {theme === 'dark' && <MdDarkMode className="w-5 h-5 text-blue-400" />}
            {theme === 'system' && <MdSettingsSystemDaydream className="w-5 h-5" />}
        </button>
    );
};

const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [stats, setStats] = useState({});
  const [activeItem, setActiveItem] = useState('Dashboard');
  const [editingGalleryId, setEditingGalleryId] = useState(null);
  const [editingNewsId, setEditingNewsId] = useState(null);
  const [editingEventId, setEditingEventId] = useState(null);
  const [editingMemberId, setEditingMemberId] = useState(null);
  const [selectedRoleFromStats, setSelectedRoleFromStats] = useState(null);
  const [selectedGenderFromStats, setSelectedGenderFromStats] = useState(null);
  const [selectedStatusFromStats, setSelectedStatusFromStats] = useState(null);
  const [selectedStateFromStats, setSelectedStateFromStats] = useState(null);
  const [selectedDistrictFromStats, setSelectedDistrictFromStats] = useState(null);
  const [receiptFilters, setReceiptFilters] = useState(null);

  const getUnviewedCount = (categoryStats, categoryPrefix) => {
    if (!categoryStats) return 0;
    const viewedIds = JSON.parse(localStorage.getItem('viewed_form_ids') || '[]');
    if (categoryStats.pending_ids && Array.isArray(categoryStats.pending_ids)) {
      const unviewed = categoryStats.pending_ids.filter(id => !viewedIds.includes(`${categoryPrefix}_${id}`));
      return unviewed.length;
    }
    return categoryStats.pending || 0;
  };

  const pressMediaUnviewed = getUnviewedCount(stats.press_media, 'press_media');
  const broadcastingUnviewed = getUnviewedCount(stats.broadcasting, 'broadcasting');
  const digitalMediaUnviewed = getUnviewedCount(stats.digital_media, 'digital_media');
  const citizenReporterUnviewed = getUnviewedCount(stats.citizen_reporter, 'citizen_reporter');

  const handleStatsClick = (role, gender = null, status = null) => {
      setSelectedRoleFromStats(role);
      setSelectedGenderFromStats(gender);
      setSelectedStatusFromStats(status);
      setSelectedStateFromStats(null);
      setSelectedDistrictFromStats(null);
      setActiveItem('All Members');
  };

  const handleMapClick = (stateVal = null, districtVal = null) => {
      setSelectedRoleFromStats(null);
      setSelectedGenderFromStats(null);
      setSelectedStatusFromStats(null);
      setSelectedStateFromStats(stateVal);
      setSelectedDistrictFromStats(districtVal);
      setActiveItem('All Members');
  };

  const handleMenuClick = (item) => {
      setSelectedRoleFromStats(null);
      setSelectedGenderFromStats(null);
      setSelectedStatusFromStats(null);
      setSelectedStateFromStats(null);
      setSelectedDistrictFromStats(null);
      setActiveItem(item);
  };

  const fetchStats = async () => {
        try {
            const response = await axios.get('/forms/dashboard-stats/');
            setStats(response.data);
        } catch (error) {
            console.error("Error fetching dashboard stats:", error);
        }
    };

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      navigate('/login');
    } else {
        const userName = localStorage.getItem('user_name');
        const userUsername = localStorage.getItem('user_username');
        const userRole = localStorage.getItem('user_role');
        setUser({ firstname: userName || userUsername || 'User', role: userRole });
        
        // Fetch stats initially
        fetchStats();
    }
  }, [navigate]);

  useEffect(() => {
    if (activeItem === 'Dashboard' && user) {
        fetchStats();
    }
  }, [activeItem, user]);

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_role');
    navigate('/login');
  };

  if (!user) return null;

  return (
    <Layout 
        user={user} 
        handleLogout={handleLogout} 
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        handleMenuClick={handleMenuClick}
    >
       {activeItem === 'Dashboard' && user && (
           <>
                <div className="mb-6">
                    <h2 className="text-xl font-semibold text-gray-800">
                        Welcome back, <span className="font-bold text-gray-900">{user.firstname}</span> (Role: {user.role || 'Member'})
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                   {/* Press Media Card */}
                   <div 
                        className="bg-white rounded-lg shadow p-6 cursor-pointer transform transition hover:scale-105"
                        onClick={() => setActiveItem('Press Media Forms')}
                   >
                        <div className="flex items-center justify-between mb-4">
                            <h2 className="text-gray-700 font-bold text-lg flex items-center gap-2">
                                Press Media
                                {pressMediaUnviewed > 0 && (
                                    <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-bold animate-pulse">
                                        New ({pressMediaUnviewed})
                                    </span>
                                )}
                            </h2>
                            <div className="p-2 rounded-full bg-blue-100 text-blue-600">
                                <SiGoogleforms className="w-6 h-6" />
                            </div>
                        </div>
                        <div className="space-y-2">
                             <div className="flex justify-between items-center text-sm">
                                  <span className="text-gray-500 font-semibold">New</span>
                                  <span className="bg-yellow-100 text-yellow-800 py-1 px-2 rounded-full font-bold">
                                      {stats.press_media?.pending || 0}
                                  </span>
                             </div>
                             <div className="flex justify-between items-center text-sm">
                                  <span className="text-gray-500">Follow Up</span>
                                  <span className="bg-orange-100 text-orange-800 py-1 px-2 rounded-full font-medium">
                                      {stats.press_media?.follow_up || 0}
                                  </span>
                             </div>
                        </div>
                   </div>

                   {/* Broadcasting Media Card */}
                   <div 
                        className="bg-white rounded-lg shadow p-6 cursor-pointer transform transition hover:scale-105"
                        onClick={() => setActiveItem('Broadcasting Media Forms')}
                   >
                        <div className="flex items-center justify-between mb-4">
                            <h2 className="text-gray-700 font-bold text-lg flex items-center gap-2">
                                Broadcasting
                                {broadcastingUnviewed > 0 && (
                                    <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-bold animate-pulse">
                                        New ({broadcastingUnviewed})
                                    </span>
                                )}
                            </h2>
                            <div className="p-2 rounded-full bg-green-100 text-green-600">
                                <SiGoogleforms className="w-6 h-6" />
                            </div>
                        </div>
                        <div className="space-y-2">
                             <div className="flex justify-between items-center text-sm">
                                  <span className="text-gray-500 font-semibold">New</span>
                                  <span className="bg-yellow-100 text-yellow-800 py-1 px-2 rounded-full font-bold">
                                      {stats.broadcasting?.pending || 0}
                                  </span>
                             </div>
                             <div className="flex justify-between items-center text-sm">
                                  <span className="text-gray-500">Follow Up</span>
                                  <span className="bg-orange-100 text-orange-800 py-1 px-2 rounded-full font-medium">
                                      {stats.broadcasting?.follow_up || 0}
                                  </span>
                             </div>
                        </div>
                   </div>

                   {/* Digital Media Card */}
                   <div 
                        className="bg-white rounded-lg shadow p-6 cursor-pointer transform transition hover:scale-105"
                        onClick={() => setActiveItem('Digital Media Forms')}
                   >
                        <div className="flex items-center justify-between mb-4">
                            <h2 className="text-gray-700 font-bold text-lg flex items-center gap-2">
                                Digital Media
                                {digitalMediaUnviewed > 0 && (
                                    <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-bold animate-pulse">
                                        New ({digitalMediaUnviewed})
                                    </span>
                                )}
                            </h2>
                            <div className="p-2 rounded-full bg-purple-100 text-purple-600">
                                <SiGoogleforms className="w-6 h-6" />
                            </div>
                        </div>
                        <div className="space-y-2">
                             <div className="flex justify-between items-center text-sm">
                                  <span className="text-gray-500 font-semibold">New</span>
                                  <span className="bg-yellow-100 text-yellow-800 py-1 px-2 rounded-full font-bold">
                                      {stats.digital_media?.pending || 0}
                                  </span>
                             </div>
                             <div className="flex justify-between items-center text-sm">
                                  <span className="text-gray-500">Follow Up</span>
                                  <span className="bg-orange-100 text-orange-800 py-1 px-2 rounded-full font-medium">
                                      {stats.digital_media?.follow_up || 0}
                                  </span>
                             </div>
                        </div>
                   </div>

                   {/* Citizen Reporter Card */}
                   <div 
                        className="bg-white rounded-lg shadow p-6 cursor-pointer transform transition hover:scale-105"
                        onClick={() => setActiveItem('Citizen Reporter Forms')}
                   >
                        <div className="flex items-center justify-between mb-4">
                            <h2 className="text-gray-700 font-bold text-lg flex items-center gap-2">
                                Citizen Reporter
                                {citizenReporterUnviewed > 0 && (
                                    <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-bold animate-pulse">
                                        New ({citizenReporterUnviewed})
                                    </span>
                                )}
                            </h2>
                            <div className="p-2 rounded-full bg-red-100 text-red-600">
                                <SiGoogleforms className="w-6 h-6" />
                            </div>
                        </div>
                        <div className="space-y-2">
                             <div className="flex justify-between items-center text-sm">
                                  <span className="text-gray-500 font-semibold">New</span>
                                  <span className="bg-yellow-100 text-yellow-800 py-1 px-2 rounded-full font-bold">
                                      {stats.citizen_reporter?.pending || 0}
                                  </span>
                             </div>
                             <div className="flex justify-between items-center text-sm">
                                 <span className="text-gray-500">Follow Up</span>
                                 <span className="bg-orange-100 text-orange-800 py-1 px-2 rounded-full font-medium">
                                     {stats.citizen_reporter?.follow_up || 0}
                                 </span>
                             </div>
                        </div>
                   </div>
                </div>

                <div className="mb-6">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Gender Statistics</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Male Members Card */}
                        <div className="bg-white rounded-lg shadow p-6 transform transition hover:scale-105">
                            <div className="flex items-center justify-between mb-4">
                                <h2 className="text-gray-700 font-bold text-lg">Male Members</h2>
                                <div className="p-2 rounded-full bg-blue-100 text-blue-600">
                                    <MdMale className="w-6 h-6" />
                                </div>
                            </div>
                            <div className="space-y-4">
                                <div 
                                    className="flex justify-between items-center p-3 bg-green-50 rounded-md cursor-pointer hover:bg-green-100 transition-colors"
                                    onClick={() => handleStatsClick(null, 'Male', 'ACTIVE')}
                                >
                                    <span className="text-gray-600 font-medium">Active Members</span>
                                    <span className="bg-green-100 text-green-800 py-1 px-3 rounded-full font-bold text-lg">
                                        {stats.gender_stats?.Male?.active || 0}
                                    </span>
                                </div>
                                <div 
                                    className="flex justify-between items-center p-3 bg-red-50 rounded-md cursor-pointer hover:bg-red-100 transition-colors"
                                    onClick={() => handleStatsClick(null, 'Male', 'EXPIRED')}
                                >
                                    <span className="text-gray-600 font-medium">Expired Members</span>
                                    <span className="bg-red-100 text-red-800 py-1 px-3 rounded-full font-bold text-lg">
                                        {stats.gender_stats?.Male?.expired || 0}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Female Members Card */}
                        <div className="bg-white rounded-lg shadow p-6 transform transition hover:scale-105">
                            <div className="flex items-center justify-between mb-4">
                                <h2 className="text-gray-700 font-bold text-lg">Female Members</h2>
                                <div className="p-2 rounded-full bg-pink-100 text-pink-600">
                                    <MdFemale className="w-6 h-6" />
                                </div>
                            </div>
                            <div className="space-y-4">
                                <div 
                                    className="flex justify-between items-center p-3 bg-green-50 rounded-md cursor-pointer hover:bg-green-100 transition-colors"
                                    onClick={() => handleStatsClick(null, 'Female', 'ACTIVE')}
                                >
                                    <span className="text-gray-600 font-medium">Active Members</span>
                                    <span className="bg-green-100 text-green-800 py-1 px-3 rounded-full font-bold text-lg">
                                        {stats.gender_stats?.Female?.active || 0}
                                    </span>
                                </div>
                                <div 
                                    className="flex justify-between items-center p-3 bg-red-50 rounded-md cursor-pointer hover:bg-red-100 transition-colors"
                                    onClick={() => handleStatsClick(null, 'Female', 'EXPIRED')}
                                >
                                    <span className="text-gray-600 font-medium">Expired Members</span>
                                    <span className="bg-red-100 text-red-800 py-1 px-3 rounded-full font-bold text-lg">
                                        {stats.gender_stats?.Female?.expired || 0}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white shadow rounded-lg p-6 mb-8 cursor-pointer" onClick={() => setActiveItem('All Members')}>
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-lg font-medium leading-6 text-gray-900">Members Details</h3>
                        <div className="p-2 rounded-full bg-blue-100 text-blue-600">
                            <MdPeople className="w-5 h-5" />
                        </div>
                    </div>
                    
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                        {[
                            "Citizen Reporter & Leader",
                            "Journalist & Leader",
                            "Journalist",
                            "District Reporter",
                            "State Reporter",
                            "Chief Reporter",
                            "Citizen Reporter",
                            "Digital Reporter",
                            "Mobile Reporter",
                            "News Informer",
                            "Volunteers"
                        ].map(role => (
                            <div 
                                key={role} 
                                onClick={() => handleStatsClick(role)}
                                className="bg-gray-50 rounded-md p-3 border border-gray-100 flex flex-col items-center justify-center text-center hover:bg-blue-50 cursor-pointer transition-colors shadow-sm"
                            >
                                <span className="text-2xl font-bold text-gray-800 mb-1">{stats.members?.[role] || 0}</span>
                                <span className="text-xs text-gray-500 font-medium">{role}</span>
                            </div>
                        ))}
                    </div>
                </div>
                
                <InteractiveMaps 
                    stats={stats} 
                    onMapClick={handleMapClick} 
                />

                <VisitorAnalyticsWidget 
                    onViewDetailed={() => setActiveItem('Visitor Statistics')}
                />
           </>
       )}

        {activeItem === 'Receipts Dashboard' && (
            <Receipts 
                view="dashboard" 
                onFYClick={(filters) => {
                    setReceiptFilters(filters);
                    setActiveItem('All Receipts');
                }}
            />
        )}
        {activeItem === 'All Receipts' && (
            <Receipts 
                view="list" 
                preSelectedFilters={receiptFilters}
                onBack={() => setActiveItem('Receipts Dashboard')}
            />
        )}

       {activeItem === 'Press Media Forms' && <PressMediaList />}
       {activeItem === 'Broadcasting Media Forms' && <BroadcastingMediaList />}
       {activeItem === 'Digital Media Forms' && <DigitalMediaList />}
       {activeItem === 'Citizen Reporter Forms' && <CitizenReporterList />}
       
       {activeItem === 'NAI News' && (
           <DashboardNaiNews 
               onAddClick={() => setActiveItem('Add NAI News')} 
               onEditClick={(id) => {
                   setEditingNewsId(id);
                   setActiveItem('Edit NAI News');
               }}
           />
       )}
       {activeItem === 'Add NAI News' && (
           <AddNaiNews onBack={() => setActiveItem('NAI News')} onNewsAdded={() => setActiveItem('NAI News')} />
       )}
        {activeItem === 'Edit NAI News' && (
            <EditNaiNews 
                newsId={editingNewsId}
                onBack={() => setActiveItem('NAI News')}
                onUpdate={() => setActiveItem('NAI News')}
            />
        )}
        {activeItem === 'NAI Events' && (
            <EventsManager 
                onAddClick={() => setActiveItem('Add Event')} 
                onEditClick={(id) => {
                    setEditingEventId(id);
                    setActiveItem('Edit Event');
                }}
            />
        )}
        {activeItem === 'Add Event' && (
            <AddEvent onBack={() => setActiveItem('NAI Events')} onEventAdded={() => setActiveItem('NAI Events')} />
        )}
        {activeItem === 'Edit Event' && (
            <EditEvent 
                eventId={editingEventId}
                onBack={() => setActiveItem('NAI Events')}
                onUpdate={() => setActiveItem('NAI Events')}
            />
        )}
       {activeItem === 'NAI Gallery' && (
            <DashboardGallery 
                onAddClick={() => setActiveItem('Add Gallery')} 
                onEditClick={(id) => {
                    setEditingGalleryId(id);
                    setActiveItem('Edit Gallery');
                }}
            />
       )}
       {activeItem === 'Add Gallery' && <AddGallery onBack={() => setActiveItem('NAI Gallery')} onGalleryAdded={() => setActiveItem('NAI Gallery')} />}
       {activeItem === 'Edit Gallery' && <EditGallery galleryId={editingGalleryId} onBack={() => setActiveItem('NAI Gallery')} onUpdate={() => setActiveItem('NAI Gallery')} />}
       
       {activeItem === 'Add Members' && <AddMember onBack={() => setActiveItem('All Members')} onMemberAdded={() => setActiveItem('All Members')} />}
        {activeItem === 'All Members' && (
            <MembersList 
                preSelectedRole={selectedRoleFromStats}
                preSelectedGender={selectedGenderFromStats}
                preSelectedStatus={selectedStatusFromStats}
                preSelectedState={selectedStateFromStats}
                preSelectedDistrict={selectedDistrictFromStats}
                onAddClick={() => setActiveItem('Add Members')} 
                onEditClick={(id) => {
                    setEditingMemberId(id);
                    setActiveItem('Edit Member');
                }}
                onMemberClick={(id) => {
                    setEditingMemberId(id);
                    setActiveItem('Member Details');
                }}
            />
        )}
       {activeItem === 'Leaders' && (
           <MembersList 
               filterType="Leader"
               preSelectedRole={selectedRoleFromStats}
               onAddClick={() => setActiveItem('Add Members')} 
               onEditClick={(id) => {
                   setEditingMemberId(id);
                   setActiveItem('Edit Member');
               }}
               onMemberClick={(id) => {
                   setEditingMemberId(id);
                   setActiveItem('Member Details');
               }}
           />
       )}
       {activeItem === 'Edit Member' && (
           <EditMember 
               memberId={editingMemberId}
               onBack={() => setActiveItem(editingMemberId ? 'Member Details' : 'All Members')}
               onUpdate={() => setActiveItem('Member Details')}
           />
       )}
        {activeItem === 'Wings' && (
            <Wings 
                onBack={() => setActiveItem('All Members')} // Or Dashboard
                onEditClick={(id) => {
                    setEditingMemberId(id);
                    setActiveItem('Edit Member');
                }}
                onMemberClick={(id) => {
                    setEditingMemberId(id);
                    setActiveItem('Member Details');
                }}
            />
        )}
       {activeItem === 'Member Details' && (
           <MemberDetails 
               memberId={editingMemberId} 
               onBack={() => setActiveItem('All Members')}
               onEdit={(id) => {
                   setEditingMemberId(id);
                   setActiveItem('Edit Member');
               }}
               onDelete={async (id) => {
                   try {
                       await axios.delete(`nai-members/members/${id}/`);
                       setActiveItem('All Members');
                   } catch (error) {
                       console.error("Error deleting member:", error);
                       alert("Failed to delete member.");
                   }
               }}
           />
       )}
        {activeItem === 'References' && <MemberReferences />}
        {activeItem === 'Visitor Statistics' && (
            <DetailedVisitorAnalytics onBack={() => setActiveItem('Dashboard')} />
        )}
        {activeItem === 'Settings' && <Settings user={user} />}

    </Layout>
  );
};

export default Dashboard;
